export const PALLAS_CAT = process.env.REACT_APP_PALLAS_CAT;
export const SAND_CAT = process.env.REACT_APP_SAND_CAT;
export const SAND_CAT_WS = process.env.REACT_APP_SAND_CAT_WS;
export const PAMPAS_CAT = process.env.REACT_APP_PAMPAS_CAT;

export const USER_AUTH_DOMAIN = "user-auth.mhome.ai";
export const DEV_AUTH_DOMAIN = "dev-auth.mhome.ai";
